/* eslint-disable no-use-before-define */
/* eslint-disable no-mixed-operators */
/* eslint-disable function-paren-newline */
// import React from 'react';
import {
    mergeParagraphListStyle,
    getBuType, fixConvertParaStyle,
} from './paragraph';

import {
    setStyleForPositionedTextInParagraphList,
    getTextLength,
    combineTextrunStyle,
    judgeTextrunsIsEmpty,
    textRunStyleMerge,
    reduceCallback,
    getFormatTime } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/utils';
import { combineParaStyles, fixParaStyle, paraStyleMerge, convertParaStyles  } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/paragraph-style';
import {
    combineCharacter,
    convertCharacter,
} from '@src/slide/domain/ui-model/element-modeles/property/text/utils/character-utils';
import { getStartEndPoint } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/selection';
import {
    getEmptyTextrun,
    mergeTextRunsStyle,
} from './textrun';
import {
    textBodyStyleMerge,
} from './textBody';
import {
    stylesToMark,
    convertMarksToStyle,
} from './mark';
import expect from '@src/slide/infrastructure/module/independent/assert/expect';
import { objectCompare } from '@src/slide/infrastructure/module/independent/assert/compare';
import { toJS } from 'mobx';
import {
    FONT_SCALE,
    TEXTRUN_STYLE_KEY,
    DEFAULT_TEXTRUN_STYLE,
    DEFAULT_PARAGRAPH_STYLE,
    DEFAULT_TEXTBODY_STYLE,
    SHOULD_DIVIDE_FONT_SCALE_PROPS,
} from '../config';
import {
    DEFAULT_RAW_FONTSIZE,
    PARAGRAPH_STYLE_KEY,
} from '@src/slide/domain/ui-model/element-modeles/property/text/constants/index';
import _get from 'lodash/get';
import _has from 'lodash/has';
import _set from 'lodash/set';
import { WrapType } from '../../../../../../../../slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';

const EMPTY_PARA = [{
    endParaRPr: {
        useEndParaStyle: true,
    },
    paragraphProps: {},
    textRuns: [{
        styles: {  // 不用设置字体，没有会自动取18
        },
        text: '',
    }],
}];

// 判断文本是否有选区
function checkHasSelection(selection) {
    if (selection && selection.anchor && selection.focus) {
        const { anchor, focus } = selection;
        if (anchor.offset === focus.offset && anchor.path && focus.path
            && anchor.path.toString() === focus.path.toString()) {
            return false;
        }
    }
    return true;
}

/**
 * 空节点添加默认节点，用于文字继承
 */
function getEmptyNodes(defaultStyle) {
    return getNodes(EMPTY_PARA, defaultStyle);
}

function getLevel(paragraph) {
    return  paragraph.paragraphProps.level || 0;
}

function getRunText(run) {
    let { text } = run;
    if (run.type === 'runBr') {
        text = '\n';
    }
    return text;
}

function getNodes(paragraphList, defaultStyle) {
    return paragraphList && paragraphList.length && Array.from(paragraphList).map((paragraph, index) => {
        const level = getLevel(paragraph);
        let paraStyle = combineParaStyles(
            paragraph.paragraphProps,
        );

        const { endParaRPr } = paragraph;
        const isParaEmpty = judgeTextrunsIsEmpty(paragraph.textRuns);
        let tabIndex = 0; // 用于判断是第几个tab，前两个tab要根据indent与paraStyle加上tabSize
        let tabFlag = true; // 判断tab用

        // 有可能某行是空的，需要给一个默认值
        const leaves = isParaEmpty
            ? [getEmptyTextrun(endParaRPr)]
            : Array.from(paragraph.textRuns).map((run, i) => {
                let marks = null;
                const styles = getRunStyles(run, i, paragraph);

                marks = stylesToMark(styles);

                // TODO tab的东西也放到style里
                const text = getRunText(run);
                // TODO 如果是第一个且之前都是tab的话，要对tab进行分区
                if (tabFlag && text) {
                    const i = text.split('').findIndex(item => item !== '\t');
                    if (i > -1) {
                        tabFlag = false;
                    }

                    // 只有tab键的情况
                    if (i === -1) {
                        return text.split('').map((item, index) => {
                            const tabSize = getTabSize(
                                index + (tabIndex += 1),
                                paraStyle.textIndent, paraStyle.marginLeft, paraStyle.tabSize * FONT_SCALE || 144,
                            );
                            tabSize && marks.push({
                                type: 'tabSize',
                                renderGroup: true,
                                data: { tabSize },
                            });

                            return {
                                marks,
                                text: item,
                            };
                        });
                    }

                    // 没有tab键的情况
                    if (i === 0) {
                        return {
                            marks,
                            text,
                        };
                    }

                    // 部分tab键的情况
                    return text.slice(0, i).split('')
                        .map((item, index) => {
                            const tabSize = getTabSize(index + (tabIndex += 1),
                                paraStyle.textIndent, paraStyle.marginLeft, paraStyle.tabSize * FONT_SCALE || 144);
                            tabSize && marks.push({
                                type: 'tabSize',
                                renderGroup: true,
                                data: { tabSize },
                            });

                            return {
                                marks,
                                text: item,
                            };
                        })
                        .concat({
                            marks,
                            text: text.slice(i),
                        });
                }

                return {
                    marks,
                    text,
                };
            })
                .reduce((prev, curr) => prev.concat(curr), []);

        const nodes = [
            {
                leaves,
                object: 'text',
                type: 'textrun',
            },
        ];

        const maxFontSize = isParaEmpty
            ? endParaRPr?.fontSize || DEFAULT_RAW_FONTSIZE
            : (paragraph.textRuns || []).reduce(
                (max, run) => ((run.styles?.fontSize || 0) > max ? run.styles?.fontSize : max)
                , paragraph.textRuns?.[0].styles?.fontSize || 0,
            ) || DEFAULT_RAW_FONTSIZE;

        paraStyle = fixParaStyle(paraStyle, maxFontSize);

        const character = combineCharacter(
            paragraph.paragraphCharacter,
        );

        const endParaRPrData = getEndParaRPrData(isParaEmpty, endParaRPr, leaves);

        const para = {
            nodes,
            object: 'block',
            type: 'para',
            data: {
                endParaRPrData, // 非空行的endPara保存到data
                index,
                style: paraStyle,
                level: paragraph.level,
            },
        };

        if (character.character) {
            para.data.character = {
                character,
                level,
            };
        }

        return para;
    }) || getEmptyNodes(defaultStyle);
}

function getRunStyles(run, i, paragraph) {
    let styles = null;
    // 如果是runBr的话，继承上一个textrun的属性值；否则给一个最小值，防止高度错误
    if (run.type === 'runBr') {
        if (i <= 0) {
            styles = combineTextrunStyle({
                textRunStyle: { fontSize: 6 },
                text: run.text,
            });
        } else {
            styles = combineTextrunStyle({
                textRunStyle: paragraph.textRuns[i - 1].styles || { fontSize: 6 },
                text: run.text,
            });
        }
    } else {
        styles = combineTextrunStyle({
            textRunStyle: run.styles,
            text: run.text,
        });
    }
    return styles;
}

function getEndParaRPrData(isParaEmpty, endParaRPr, leaves) {
    if (!isParaEmpty && endParaRPr && leaves) {
        const lastTextRun = leaves.length > 0 ? leaves[leaves.length - 1] : null;
        const text = lastTextRun ? lastTextRun.text : '';
        const lastChar = (text && text.length > 0) ? text[text.length - 1] : '';
        return {  // 后面数据用来对比，有变更就丢弃endPara
            endParaRPr,
            pLen: leaves.length,
            lastRunLen: text ? text.length : 0,
            lastChar,
        };
    }
    return null;
}

/**
 * 判断大于marginLeft所需的最少tab
 * @param {*} tabSize
 * @param {*} marginLeft
 */
// function findTabSize(tabSize, marginLeft) {
//     let s = Math.floor(marginLeft / tabSize);
//     (marginLeft % tabSize !== 0) && (s++);
//     return s;
// }

/**
 * tab长度
 * 临时规则，tab长度的转换主要针对于悬挂缩进下第一个tab对应的宽度，所以只对悬挂缩进下的第一个tab进行处理，后续tab由于office与web对于起始点的定义不一致，一定会有不同，暂不处理
 * @param {*} index 第几个tab
 * @param {*} indent text-indent长度
 * @param {*} marginLeft 缩进长度
 */
function getTabSize(index, indent, marginLeft, tabSize) {
    // 文本框的tab设置是从文字区开始，而非文本框开始，所以要转换
    if (index > 2) return;
    if (!indent || !tabSize) return;

    if (index === 0) {
        if (indent < 0) {
            // 悬挂缩进
            return Math.min(-1 * indent, marginLeft);
        }
        // 首行缩进
        // if (tabSize > indent) {
        //     // debugger
        //     return tabSize - indent;
        // }
    }

    // if (index === 1) {
    //     // 悬挂缩进
    //     if (indent < 0) {
    //         return tabSize * findTabSize(tabSize, marginLeft) + Math.min(-1 * indent, marginLeft) - marginLeft;
    //     }
    // }

    // if (index === 2) {
    //     // 悬挂缩进
    //     if (indent < 0) {
    //          return tabSize * (findTabSize(tabSize, marginLeft) + 1)
    //              + Math.min(-1 * indent, marginLeft) - marginLeft;
    //     }
    // }
}


class DataManage {
    constructor(paragraphList, defaultStyle, triggerUpdate, triggerStateChange, option) {
        this.paragraphList = paragraphList;
        this.defaultStyle = defaultStyle;
        this.triggerUpdate = triggerUpdate;
        this.triggerStateChange = triggerStateChange;
        this.selection = null;
        this.option = option;

        // 给editor用的value
        this.editorValue = DataManage.convertFromObject(paragraphList, defaultStyle, option);
        this.searchResult = [];
        this.highlightResult = [];
        this.isHighlightFlag = false;
        this.isSearchingFlag = false;
        this.keyword = '';
    }

    static judgeTextIsEmpty(paragraphList) {
        if (!paragraphList) return true;
        const p = toJS(paragraphList);
        if (!p) return true;
        if (!p.length) return true;
        if (p.length === 1) {
            if (!p[0].textRuns || !p[0].textRuns.length) return true;
            if (DataManage.hasNoTextInPara(p[0])) return true;
        }
        return false;
    }

    static hasNoTextInPara(p0) {
        return p0.textRuns.length === 1 && (!p0.textRuns[0].text || p0.textRuns[0].text === '\uFEFF');
    }

    /**
     * 组装slate数据格式
     * @param {Array} paragraphList 文本内容
     * @param {Object} defaultStyle 空文字段初始化使用的style
     */
    static convertFromObject(paragraphList, defaultStyle, option) {
        let nodes = getEmptyNodes(defaultStyle);

        const resizeLevel = _get(option, 'resizeLevel');
        const slideNum = _get(option, 'slideNum');
        const datetime = _get(option, 'datetime');
        const textDirection = _get(option, 'textDirection');

        if (paragraphList && paragraphList.length) {
            nodes = Array.from(paragraphList).map((paragraph, index) => {
                const level = this.getCurLevel(paragraph);
                let paraStyle = combineParaStyles(
                    paragraph.paragraphProps,
                );

                const { endParaRPr } = paragraph;
                const isParaEmpty = judgeTextrunsIsEmpty(paragraph.textRuns);
                let tabIndex = 0; // 用于判断是第几个tab，前两个tab要根据indent与paraStyle加上tabSize
                let tabFlag = true; // 判断tab用

                // 有可能某行是空的，需要给一个默认值
                const leaves = isParaEmpty
                    ? [getEmptyTextrun(endParaRPr, resizeLevel)]
                    : Array.from(paragraph.textRuns).map((run, i) => {
                        let marks = null;
                        const styles = this.computeStyles(run, i, paragraph, resizeLevel);

                        marks = stylesToMark(styles);
                        const text = this.getRunText(run, slideNum, datetime);

                        // 页眉页脚的fieldType和id转换进marks
                        if (run.type === 'field') {
                            marks.push({
                                type: 'fieldType',
                                data: {
                                    fieldType: run.fieldType,
                                    fieldId: run.fieldId,
                                },
                                markNotExtend: true,
                                notExtendFront: true,
                                disableSplit: true,
                            });
                        }

                        // TODO 如果是第一个且之前都是tab的话，要对tab进行分区
                        if (tabFlag && text) {
                            const flagAndIndex = this.checkTabFlag(text, tabFlag);
                            // eslint-disable-next-line prefer-destructuring
                            tabFlag = flagAndIndex.tabFlag;
                            const { i } = flagAndIndex;

                            // 只有tab键的情况
                            if (i === -1) {
                                return text.split('').map((item, index) => {
                                    const tabSize = getTabSize(index + (tabIndex += 1), paraStyle.textIndent,
                                        paraStyle.marginLeft, paraStyle.tabSize * FONT_SCALE || 144);
                                    tabSize && marks.push({
                                        type: 'tabSize',
                                        renderGroup: true,
                                        data: { tabSize },
                                    });

                                    return {
                                        marks,
                                        text: item,
                                    };
                                });
                            }

                            // 没有tab键的情况
                            if (i === 0) {
                                return {
                                    marks,
                                    text,
                                };
                            }

                            // 部分tab键的情况
                            return text.slice(0, i).split('')
                                .map((item, index) => {
                                    const tabSize = getTabSize(index + (tabIndex += 1), paraStyle.textIndent,
                                        paraStyle.marginLeft, paraStyle.tabSize * FONT_SCALE || 144);
                                    tabSize && marks.push({
                                        type: 'tabSize',
                                        renderGroup: true,
                                        data: { tabSize },
                                    });

                                    return {
                                        marks,
                                        text: item,
                                    };
                                })
                                .concat({
                                    marks,
                                    text: text.slice(i),
                                });
                        }

                        return {
                            marks,
                            text,
                        };
                    })
                        .reduce((prev, curr) => prev.concat(curr), []);

                const nodes = [
                    {
                        leaves,
                        object: 'text',
                        type: 'textrun',
                    },
                ];

                const maxFontSize = isParaEmpty
                    ? endParaRPr?.fontSize || DEFAULT_RAW_FONTSIZE
                    : (paragraph.textRuns || []).reduce(
                        (max, run) => ((run.styles?.fontSize || 0) > max ? run.styles?.fontSize : max)
                        , paragraph.textRuns?.[0].styles?.fontSize || 0,
                    ) || DEFAULT_RAW_FONTSIZE;
                paraStyle = fixParaStyle(paraStyle, maxFontSize);

                const character = combineCharacter(
                    paragraph.paragraphCharacter,
                );

                const endParaRPrData = this.getEndParaData(isParaEmpty, endParaRPr, leaves);

                const para = {
                    nodes,
                    object: 'block',
                    type: 'para',
                    data: {
                        endParaRPrData, // 非空行的endPara保存到data
                        index,
                        style: paraStyle,
                        level: paragraph.level,
                    },
                };

                if (character.character) {
                    para.data.character = {
                        character,
                        level,
                    };
                }

                return para;
            });
        }

        const raw = {
            document: {
                nodes,
                data: {
                    textDirection,
                },
            },
        };

        return raw;
    }

    static getRunText(run, slideNum, datetime) {
        let { text } = run;
        if (run.type === 'runBr') {
            text = '\n';
        }
        // textrun类型为幻灯片编号，text取当前页码为值
        if (run.fieldType === 'slidenum' && !expect(slideNum).isNullOrUndefined()) {
            text = `${slideNum}`;
        }
        // textrun类型为日期与时间，text取当前当前格式的时间
        if (this.isDatetimeType(run)) {
            const time = getFormatTime(run, datetime);
            text = `${time}`;
        }
        return text;
    }

    static isDatetimeType(run) {
        return run.fieldType && run.fieldType.indexOf('datetime') > -1;
    }

    static getEndParaData(isParaEmpty, endParaRPr, leaves) {
        let endParaRPrData;
        if (this.hasEndPara(isParaEmpty, endParaRPr, leaves)) {
            const lastTextRun = leaves.length > 0 ? leaves[leaves.length - 1] : null;
            const text = lastTextRun ? lastTextRun.text : '';
            const lastChar = (text && text.length > 0) ? text[text.length - 1] : '';
            endParaRPrData = {  // 后面数据用来对比，有变更就丢弃endPara
                endParaRPr,
                pLen: leaves.length,
                lastRunLen: text ? text.length : 0,
                lastChar,
            };
        }
        return endParaRPrData;
    }

    static hasEndPara(isParaEmpty, endParaRPr, leaves) {
        return !isParaEmpty && endParaRPr && leaves;
    }

    static checkTabFlag(text, flag) {
        let tabFlag = flag;
        const i = text.split('').findIndex(item => item !== '\t');
        if (i > -1) {
            tabFlag = false;
        }
        return { i, tabFlag };
    }

    static getCurLevel(paragraph) {
        return (paragraph && paragraph.paragraphProps && paragraph.paragraphProps.level) || 0;
    }

    static computeStyles(run, i, paragraph, resizeLevel) {
        let styles = null;
        // 使用继承的fontSize或默认fontSize
        styles = combineTextrunStyle({
            textRunStyle: run.styles,
            text: run.text,
            resizeLevel,
        });
        return styles;
    }

    /**
     * 从slate数据转换回ui-model数据
     * @param {*} raw
     * @param {*} resizable 是否自缩排
     * @param {*} param2.inherit 是否根据继承规则转换，默认根据
     */
    static convertFromRaw(raw, resizable, { inherit = true } = {}) {
        let paragraphList = raw.document.nodes.map(node => { // eslint-disable-line
            const textNode = node.nodes.length ? node.nodes[node.nodes.length - 1] : null;
            let endParaRPr;
            const x = {
                textRuns: textNode
                    && textNode.leaves
                    && textNode.leaves.map((run, index) => {
                        if (run.text === '\n') {
                            return {
                                type: 'runBr',
                                props: {
                                    lang: 'en-US',
                                },
                                text: '\n',
                            };
                        }

                        const y = {
                            text: run.text,
                            styles: convertMarksToStyle(run.marks),
                            type: 'run',
                        };

                        // 页眉页脚属性转换回ui-model数据
                        if (_has(y.styles, 'fieldType')) {
                            y.type = 'field';
                            y.fieldType = y.styles.fieldType;
                            y.fieldId = y.styles.fieldId;
                        }

                        if (resizable) {
                            // 自缩排更新字体应为 displayFontSize
                            y.styles.fontSize = y.styles.displayFontSize;
                        }

                        if (inherit) {
                            // 根据raw-前缀转换
                            y.styles = y.styles ? Object.keys(y.styles)
                                .filter(key => key.includes('raw-'))
                                .map(key => key.slice(4))
                                .reduce(reduceCallback(y), {}) : {};
                        } else {
                            y.styles = y.styles ? Object.keys(y.styles)
                                .filter(key => !key.includes('raw-'))
                                .reduce(reduceCallback(y), {}) : {};
                        }

                        y.styles.fontSize && (y.styles.fontSize /= FONT_SCALE);
                        // 处理结尾TextRun
                        endParaRPr = this.getEndParaProps(y, run, index, textNode);
                        return y;
                    }) || [],
            };

            const paragraphProps = convertParaStyles(node.data);
            x.paragraphProps = paragraphProps || {};

            if (endParaRPr) {
                x.endParaRPr = endParaRPr;
            }

            this.fixEmptyPara(x);

            let paragraphCharacter = null;
            if (node.data && node.data.character) {
                if (inherit) {
                    paragraphCharacter = convertCharacter(node.data.character);
                } else {
                    paragraphCharacter = node.data.character && node.data.character.character;
                    paragraphCharacter = paragraphCharacter && { ...paragraphCharacter };
                    delete paragraphCharacter.raw;
                }
                if (paragraphCharacter) {
                    x.paragraphCharacter = paragraphCharacter;
                }
            }

            if (node.data && node.data.endParaRPrData) {  // 转换endPara,如果有修改，丢弃endPara
                this.convertEndPara(node, textNode, x);
            }

            return x;
        });
        return paragraphList;
    }

    static fixEmptyPara(paragraph) {
        const para = paragraph;
        let pTextRuns;
        if (Array.isArray(para.textRuns)) {
            // 去除空的textRun
            pTextRuns = para.textRuns.filter(item => item.type === 'runBr' || item.text);
        }
        if (pTextRuns && pTextRuns.length === 0) { // 自己产生的空行,设置endParaRPr并使用空的textRun的样式
            const emptyTextRun = para.textRuns.length > 0 ? para.textRuns[0] : null;
            if (emptyTextRun && emptyTextRun.styles) {
                para.endParaRPr = emptyTextRun.styles;
            }
        }
        para.textRuns = pTextRuns;
    }

    static getEndParaProps(y, run, index, textNode) {
        let endParaRPr;
        const { styles } = y;
        if (styles.useEndParaStyle) {
            if (!run.text && index === textNode.leaves.length - 1) { // 尾TextRun没被修改
                endParaRPr = styles;
            } else {
                delete styles.useEndParaStyle;
            }
        }
        return endParaRPr;
    }

    static convertEndPara(node, textNode, x) {
        const endParaData = node.data.endParaRPrData;
        const { leaves } = textNode;
        const lastTextRun = (leaves && leaves.length) > 0 ? leaves[leaves.length - 1] : null;
        const text = lastTextRun ? lastTextRun.text : '';
        const lastChar = (text && text.length > 0) ? text[text.length - 1] : '';
        if (this.shouldConvertEndPara(leaves, endParaData, text, lastChar)) {
            // eslint-disable-next-line no-param-reassign
            x.endParaRPr = endParaData.endParaRPr;
        }
    }

    static shouldConvertEndPara(leaves, endParaData, text, lastChar) {
        return leaves && endParaData.pLen === leaves.length && endParaData.lastRunLen === (text ? text.length : 0)
            && (endParaData.lastChar === lastChar || (!lastChar && !endParaData.lastChar));
    }

    static getSelection(selection) {
        let startIndex = null;
        let endIndex = null;
        let startOffset = null;
        let endOffset = null;

        // start, end 可能相反
        if (selection && selection.anchor && selection.focus) {
            let start = selection.anchor;
            let end = selection.focus;
            if (
                start.path[0] > end.path[0]
                || (start.path[0] === end.path[0] && start.offset > end.offset)
            ) {
                start = selection.focus;
                end = selection.anchor;
            }

            startIndex = start.path[0];
            endIndex = end.path[0];
            startOffset = start.offset;
            endOffset = end.offset;
        }

        return {
            startIndex,
            endIndex,
            startOffset,
            endOffset,
        };
    }

    static getLeaves(nodes) {
        return (nodes && nodes[0] && nodes[0].leaves) || null;
    }

    static getTextRunStyle(paragraph, index = 0) {
        const slateData = DataManage.convertFromObject([paragraph]);
        const slateRun = slateData.document.nodes[index < 0 ? 0 : index].nodes[0].leaves[0];
        const markList = slateRun.marks;

        const style = markList.reduce((prev, mark) => ({
            ...prev,
            ...mark.data,
        }), {});

        if (style.fontSize) {
            style.fontSize /= FONT_SCALE;
        }

        return textRunStyleMerge(
            DEFAULT_TEXTRUN_STYLE,
            TEXTRUN_STYLE_KEY.reduce((prev, key) => {
                if (style[key]) prev[key] = style[key];
                return prev;
            }, {}),
        );
    }

    static getParagraphStyle(paragraph) {
        const slateData = DataManage.convertFromObject([paragraph]);
        const slateParagraph = slateData.document.nodes[0];

        const style = slateParagraph.data && slateParagraph.data.style;
        const paragraphStyle = paraStyleMerge(
            DEFAULT_PARAGRAPH_STYLE,
            PARAGRAPH_STYLE_KEY.reduce((prev, key) => {
                if (style[key]) prev[key] = style[key];
                return prev;
            }, {}),
        );

        // 上面转换之后，这些值都会变成FONT_SCALE倍，需要还原回去
        SHOULD_DIVIDE_FONT_SCALE_PROPS.forEach((prop) => {
            if (Object.prototype.hasOwnProperty.call(paragraphStyle, prop)) {
                paragraphStyle[prop] = paragraphStyle[prop] / FONT_SCALE;
            }
        });
        if (paragraphStyle.lineHeightIs === 'absolute' && paragraphStyle.lineHeight) {
            paragraphStyle.lineHeight = paragraphStyle.lineHeight / FONT_SCALE;
        }

        const buType = getBuType(paragraphStyle);
        buType && (paragraphStyle.buType = buType);

        return paragraphStyle;
    }

    static getTextBodyStyle(textBodyStyle) {
        return textBodyStyleMerge(
            DEFAULT_TEXTBODY_STYLE,
            textBodyStyle,
        );
    }

    static setStyleForTextBody({
        paragraphList,
        textBodyStyle,
    } = {}, {
        textRunStyle,
        paraStyle,
        wrapperStyle,
        bodyStyle,
        autoFitType,
    } = {}, selection = null) {
        let pL = paragraphList && JSON.parse(JSON.stringify(paragraphList)) || null;
        const n = {};

        this.updateTextBodyStyle(wrapperStyle, bodyStyle, textBodyStyle, autoFitType, n);

        if (pL) {
            let sIndex = 0;
            let eIndex = pL.length - 1;
            let sOffset = 0;
            let eOffset = 0;
            if (selection) {
                const startEndPoint = getStartEndPoint(selection.anchor, selection.focus);
                sIndex = startEndPoint.sIndex;
                eIndex = startEndPoint.eIndex;
                sOffset = startEndPoint.sOffset;
                eOffset = startEndPoint.eOffset;
            }

            pL = mergeParagraphListStyle(pL, paraStyle, sIndex, eIndex);
            for (let i = sIndex; i <= eIndex; i++) {
                const s = (selection && sIndex === i) ? sOffset : 0;
                const e = (selection && eIndex === i) ? eOffset : getTextLength(pL[i]);
                pL[i].textRuns = mergeTextRunsStyle(pL[i].textRuns, textRunStyle, s, e);
            }
            n.paragraphList = pL;
        }

        return n;
    }

    static updateTextBodyStyle(wrapperStyle, bodyStyle, textBodyStyle, autoFitType, n) {
        let tS = this.getBodyStyle(textBodyStyle);
        if (wrapperStyle || bodyStyle) tS = tS || {};

        if (!tS) return;

        if (tS.wrapperStyle || wrapperStyle) {
            tS.wrapperStyle = {
                ...tS.wrapperStyle,
                ...wrapperStyle,
            };
            // 横排文本默认没有textDirection属性，手动赋值防止格式刷属性合并错误
            tS.wrapperStyle.textDirection = wrapperStyle.textDirection;
        }

        if (tS.bodyStyle || bodyStyle) {
            const whiteSpace = this.getWhiteSpace(bodyStyle);
            tS.bodyStyle = {
                ...tS.bodyStyle,
                ...bodyStyle,
                whiteSpace,
            };
        }

        if (autoFitType) {
            tS.autoFitType = autoFitType;
        }

        // eslint-disable-next-line no-param-reassign
        n.textBodyStyle = tS;
    }

    static getWhiteSpace(bodyStyle) {
        return _get(bodyStyle, 'whiteSpace') || WrapType.WRAP;
    }

    static getBodyStyle(textBodyStyle) {
        return textBodyStyle && JSON.parse(JSON.stringify(textBodyStyle)) || null;
    }

    _setSearch = (paragraphList) => {
        if (!(this.isSearchingFlag || this.isHighlightFlag)) {
            return paragraphList;
        }

        // TODO 可优化
        let pList = paragraphList;
        if (this.isSearchingFlag && this.searchResult) {
            pList = setStyleForPositionedTextInParagraphList(paragraphList, this.searchResult, this.keyword, {
                search: true, // TOOD
            });
        }
        if (this.isHighlightFlag && this.highlightResult) {
            pList = setStyleForPositionedTextInParagraphList(pList, this.highlightResult, this.keyword, {
                highlight: true, // TOOD
            });
        }

        return pList;
    };

    // 根据新获取的raw data, 转换出新的数据比较
    // 如果转化出的结果需要改变，返回true, 否则返回false
    setRawData = ({
        paragraphList = this.paragraphList,
        defaultStyle = this.defaultStyle,
        option = this.option,
    } = {}, {
        needUpdate = true, // 是否需要更新
        // resistSelection = false, // 默认不保留selection状态
        resistSelection = true, // 默认保留selection状态
        resistStyle = true, // 默认保留style
        selection = this.selection,
    } = {}) => {
        const resizeLevel = (_has(option, 'resizeLevel')) ? option.resizeLevel : null;
        let isDifferentResizeLevel = false;
        if (!expect(resizeLevel).isNullOrUndefined()) {
            isDifferentResizeLevel = (this.option?.resizeLevel !== resizeLevel);
            _set(this.option, 'resizeLevel', resizeLevel);
        }

        const fixedParagraphList = this._setSearch(paragraphList);
        const nV = DataManage.convertFromObject(fixedParagraphList, defaultStyle, option);

        const nU = this.needUpdate(needUpdate, paragraphList, resistSelection, selection, isDifferentResizeLevel);

        this.notifyUpdateState(option, nU);  // 抛出是否更新textBody的状态

        this.editorValue = nV;
        this.paragraphList = paragraphList;
        if (nU) { // TODO 取消的原因是因为基础的editor中还做了一层比较，所以必须同步，之后改成只有一层的话就在某些情况下不需要setState了
            const textBody = {
                ...this.editorValue,
            };

            // 选择区重选
            if (resistSelection && selection) {
                // 这里需要把marks去掉，默认只保留选中位置
                this.selection = JSON.parse(JSON.stringify(selection));
                if (!resistStyle) {
                    this.selection.marks = null;
                }
                textBody.selection = selection;
            }

            return this.triggerUpdate({ textBody });
        }

        return Promise.resolve();
    };

    needUpdate() {
        // return needUpdate && (!editorCompareEngine.compare(this.paragraphList, paragraphList) // value不一致
        //     || (resistSelection && !objectCompare(selection, this.selection)) // selection不一致
        //     || isDifferentResizeLevel // 缩排等级不同
        // );
    }

    notifyUpdateState(option, nU) {
        if (option && option.checkUpdateState) {
            option.checkUpdateState(nU); // 抛出更新状态
        }
    }

    // TODO 多选使用，暂时不提供刷新回调，也不考虑selection的保留
    setRawDataSync({
        paragraphList = this.paragraphList,
        defaultStyle = this.defaultStyle,
    }) {
        this.paragraphList = paragraphList;

        const nV = DataManage.convertFromObject(paragraphList, defaultStyle);

        // eslint-disable-next-line max-len
        if (!objectCompare(this.editorValue, nV)) { // TODO 取消的原因是因为基础的editor中还做了一层比较，所以必须同步，之后改成只有一层的话就在某些情况下不需要setState了
            this.editorValue = nV;

            const textBody = {
                ...this.editorValue,
            };

            this.triggerUpdate({ textBody });
        }

        this.editorValue = nV;
    }

    setWrapperStyle({
        wrapperStyle = this.wrapperStyle,
    }) {
        this.wrapperStyle = wrapperStyle;
        return this.triggerStateChange('wrapperStyle', this.wrapperStyle);
    }

    getRawData() {
        return this.editorValue;
    }

    setSelection(selection) {
        this.selection = selection;
    }
    /**
     * 根据平铺的offset与length，找到对应每个textRun的paragraphIndex，textRunIndex，offset与length
     * @param {*} offset
     * @param {*} length
     */
    getSelection(offset, length) {
        if ((offset === 0 && length === 0) || !this.paragraphList.length) {
            return [
                {
                    paragraphIndex: 0,
                    textRunIndex: 0,
                    offset,
                    length,
                },
            ];
        }

        const arr = [];
        let o = 0;
        this.paragraphList.forEach(({ textRuns }, i) => {
            textRuns.forEach(({ text }, j) => {
                // 当插入片段正好在两段textrun中间的时候，需要判断
                // 当是
                // if (length === 0 && o + text.length === )

                if (o > offset + length - 1 || offset > o + text.length - 1) {
                    o += text.length;
                    return;
                }

                const textRunOffset = Math.max(o, offset) - o;
                const textRunlength = Math.min(o + text.length, offset + length) - textRunOffset - o;
                o += text.length;

                arr.push({
                    paragraphIndex: i,
                    textRunIndex: j,
                    offset: textRunOffset,
                    length: textRunlength,
                });
            });
        });

        return arr;
    }

    /**
     * 添加查询
     * @param {object} result
     */
    addSearchMark(result, keyword) {
        if (!this.isSearchingFlag) {
            this.isSearchingFlag = true;
            this.searchResult = result;
            this.keyword = keyword;
            return true;
        }
        return false;
    }

    removeSearchMark() {
        if (this.isSearchingFlag) {
            this.isSearchingFlag = false;
            this.searchResult = [];
            this.keyword = '';
            return true;
        }
        return false;
    }

    addHighlight(result, keyword) {
        if (!this.isHighlightFlag) {
            this.isHighlightFlag = true;
            this.highlightResult = result;
            this.keyword = keyword;
            return true;
        }
        return false;
    }

    removeHighlight() {
        if (this.isHighlightFlag) {
            this.isHighlightFlag = false;
            this.highlightResult = [];
            return true;
        }
        return false;
    }
}

export default DataManage;

// 用于单元测试导出
export const testTable = {
    checkHasSelection,
    getLevel,
    getRunText,
    getEndParaRPrData,
    fixParaStyle,
    fixConvertParaStyle,
};
